import { motion } from "framer-motion";
import { Heart, Quote } from "lucide-react";
import { REVIEWS } from "@/data/site";

const TONES = ["bg-blush-soft", "bg-leaf-soft", "bg-peach", "bg-lilac", "bg-cream-deep"];
const SPANS = ["md:col-span-2", "md:col-span-2", "md:col-span-2", "md:col-span-3", "md:col-span-3"];
const TILTS = ["md:-rotate-1", "md:rotate-1", "md:-rotate-1", "md:rotate-1", "md:-rotate-1"];

export default function Reviews() {
    return (
        <section
            id="reviews"
            data-testid="reviews-section"
            className="mx-auto max-w-6xl px-4 py-20 sm:px-6 sm:py-28"
        >
            <div className="text-center">
                <p className="eyebrow">Sweet words</p>
                <h2 className="mt-3 font-serif text-4xl font-semibold tracking-tight text-cocoa sm:text-5xl">
                    happy customers
                </h2>
            </div>

            <div className="mt-12 grid grid-cols-1 gap-4 sm:gap-5 md:grid-cols-6">
                {REVIEWS.map((review, i) => (
                    <motion.figure
                        key={i}
                        data-testid={`review-card-${i}`}
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.2 }}
                        transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                        className={`flex h-full flex-col rounded-[1.75rem] p-6 transition-transform duration-300 hover:rotate-0 sm:p-7 ${TONES[i]} ${SPANS[i]} ${TILTS[i]}`}
                    >
                        <Quote className="size-6 fill-gold/40 text-gold/40" />
                        <blockquote className="mt-3 flex-1 font-serif text-lg italic leading-snug text-cocoa sm:text-xl">
                            “{review.text}”
                        </blockquote>
                        <figcaption className="mt-5 flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.18em] text-leaf">
                            <Heart className="size-3.5 fill-current" />
                            {review.author}
                        </figcaption>
                    </motion.figure>
                ))}
            </div>
        </section>
    );
}
